import React, { useState } from 'react';

const MenuContext = React.createContext([{}, () => {}]);

const MenuProvider = props => {
  const [open, setOpen] = useState(false);
  const toggleVisibility = () => setOpen(!open);
  return <MenuContext.Provider value={[open, toggleVisibility]}>{props.children}</MenuContext.Provider>;
};

export { MenuContext, MenuProvider };
